module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _c('em', [_vm._v("Window: Thing as Participle")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Welling and flowing and fastening, too,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the window itself became the fever,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("faces waved and surfed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("across its surface . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Stop that, she rebuked herself,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("people are only passing on the sidewalk,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("people are simply walking on the sidepass, yes,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("that’s all you’re seeing, so much")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("water in an eye. But then the sneezes rose")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("from somewhere to attack")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("whole buildings, schools and churches,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("massive stoneworks, city hall—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("whatever stood, stood to be wracked—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("did no one notice? They were all")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("at risk: whatever the window held")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("could tremble. Mortified, she sat")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("in the eye of the storm, with steam")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("from cups of cure to drape")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("or dramatize her time away; but still")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the window went on streaming")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("all these bundled half-lives by, in one")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("continuous unravelling of differences, of")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("higher, lower, lighter, darker,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("faces framed in fur or bared of head,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("blown blond or blasted black, each one appointed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in a halo’s freeze-burn or an aura’s sun-chill,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("each one with its hunch of forehead, over")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("only two hot coals per person . . .")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Humankind was understandable in this")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("unending sentence of an "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EEG")]), _vm._v(" she witnessed")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("scrolling by; it was, at each new moment, modelled")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("into spikes of single-mindedness; but every")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("bobbing of discreteness in the flow, each")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("block or chunk, each head, she knew")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("(she knew) had its")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("own helixing and coils")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("of orienting endlessness, its moving")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("windows of reflective flux,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and its own someone")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in a fix: that figure")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("underlying everything, that glimpse")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("in brown or blue, with fringe of lash:")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a holy icon, prize of self, an image")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("irrecoverably, shimmeringly")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("still, it is so deeply")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("plunged into the nominative . . .")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181c301d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter03.vue
// module id = 90
// module chunks = 0